import React from 'react';

import useSearchStore from '../../_Global/SearchStore';

function SearchFilterContainer() {
    const resetSearchFacetSelections = useSearchStore((state) => state.resetSearchFacetSelections);

    /**
     * Respond to changes to the "clear all tags" input
     *
     * @returns void
     */
    const onClearTagsClick = () => {
        // Reset all stored Facet data
        resetSearchFacetSelections();
    };

    return (
        <button className="button button--utility" role="button" onClick={onClearTagsClick}>
            <svg className="button__icon">
                <use xlinkHref="#reset"></use>
            </svg>
            <span className="button__label body-size-sm">Clear filters</span>
        </button>
    );
}

export default React.memo(SearchFilterContainer);
